import React from 'react'
import { useSelector } from 'react-redux'
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const Spinner = () => {
    const loading = useSelector(state => state.spinner.loading);

    return (
        <Backdrop style={{ zIndex: 9999 }} open={loading}>
            <CircularProgress style={{ color: 'white' }} />
        </Backdrop>
    );
};

export default Spinner;